/**
 * Source: https://play.tailwindcss.com/LDVKItfSae?file=css
 */
module.exports = () => ({
  ".footer": {
    "@apply ds-bg-background-bluealt ds-pt-xl": {},
  },
  ".footer-content": {
    "@apply ds-relative ds-flex ds-flex-col ds-justify-center ds-items-center ds-py-2xl ds-px": {},
  },
  ".footer-content > h2": {
    "@apply ds-mb-xs ds-h2 ds-text-center": {},
  },
  ".footer-content > p": {
    "@apply ds-mb-sm ds-text-center sm:ds-w-2/3": {},
  },
  ".footer > nav:nth-child(1)": {
    "@apply ds-container ds-mx-auto ds-grid ds-grid-cols-1 md:ds-grid-cols-2 lg:ds-grid-cols-3 xl:ds-grid-cols-5 ds-gap md:ds-gap-lg ds-py md:ds-pt-lg ds-max-w-[1410px] ds-px":
      {},
  },
  ".footer-navigation-section": {
    "@apply ds-flex md:ds-flex-col ds-flex-wrap": {},
  },
  ".footer-navigation-section > label": {
    "@apply ds-text-base ds-font-bold ds-cursor-pointer md:ds-cursor-default hover:ds-text-primary-blue md:hover:ds-text-primary-black":
      {},
  },
  ".footer-navigation-section > nav": {
    "@apply ds-text-base ds-font-medium ds-mt-xs md:ds-mt-sm ds-w-full ds-ml-[2.25rem] md:ds-ml-0": {},
  },
  ".footer-navigation-section > nav a": {
    "@apply ds-text-primary-black hover:ds-text-primary-blue ds-mb-xs ds-block": {},
  },
  ".footer-navigation-section input": {
    "@apply ds-appearance-none ds-icon ds-icon-bottom checked:ds-icon-up ds-cursor-pointer ds-w-[2.25rem] ds-border-tertiary-lightgrey hover:ds-text-primary-blue hover:ds-bg-background-blue md:ds-hidden":
      {},
  },
  ".footer-navigation-section > input + label ~ nav": {
    "@apply ds-hidden md:ds-block": {},
  },
  ".footer-navigation-section > input:checked + label ~ nav": {
    "@apply ds-block": {},
  },
  "section:not([class]) > label": {
    "@apply ds-text-base ds-font-bold": {},
  },
  "section:not([class]) > nav": {
    "@apply ds-space-x ds-mt-xs md:ds-mt-sm": {},
  },
  "section:not([class]) > nav a": {
    "@apply ds-text-primary-black hover:ds-text-primary-blue": {},
  },
  "section:not([class]) > nav a:hover": {
    "@apply before:ds-bg-primary-blue": {},
  },
  ".footer > nav:nth-child(2)": {
    "@apply ds-container ds-mx-auto ds-grid ds-grid-cols-1 ds-gap-sm md:ds-grid-cols-2 ds-border-t ds-border-primary-white ds-py md:ds-pt xl:ds-pb-xl ds-max-w-[1410px] ds-px":
      {},
  },
  ".footer > nav:nth-child(2) > nav": {
    "@apply ds-text-base ds-font-medium md:ds-text-right md:ds-space-x": {},
  },
  ".footer > nav:nth-child(2) > nav a": {
    "@apply ds-text-primary-black hover:ds-text-primary-blue ds-block md:ds-inline": {},
  },
});
